import React from "react";

import MemberStore from "../../stores/MemberStore";
import ProfileStore from "../../stores/ProfileStore";
import EventPublisher from "../../utils/EventPublisher";
import StoreUpdateEvents from "../../constants/events/StoreUpdateEvents";
import LoadingStates from "../../constants/states/LoadingStates";
import Logger from "../../utils/Logger";
import PrivateWrapper from "./PrivateWrapper";
import PropTypes from "prop-types";
import UIInteractionEvents from "../../constants/events/UIInteractionEvents";
import LoadingView from "../views/LoadingView";
import ForcedViewPrivateWrapper from "./ForcedViewPrivateWrapper";
import ProfileCreateContainer from "../containers/ProfileCreateContainer";
import EmailVerificationContainer from "../containers/EmailVerificationContainer";
import PhoneNumberVerificationContainer from "../containers/PhoneNumberVerificationContainer";


class PrivateWrapperContainer extends React.Component {

    static propTypes = {
        children: PropTypes.object.isRequired,
        usesDefaultFooter: PropTypes.bool.isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            "memberState": MemberStore.getState(),
            "profileState": ProfileStore.getState()
        }
    }

    componentDidMount() {
        this.memberStoreSubscriber =
            EventPublisher.subscribe(StoreUpdateEvents.MEMBER_STORE_UPDATED, this.handleStoreUpdate);
        this.profileStoreSubscriber =
            EventPublisher.subscribe(StoreUpdateEvents.PROFILE_STORE_UPDATED, this.handleStoreUpdate);
        this.requestViewRequiredData();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.requestViewRequiredData();
    }

    componentWillUnmount() {
        EventPublisher.unsubscribe(this.memberStoreSubscriber);
        EventPublisher.unsubscribe(this.profileStoreSubscriber);
    }

    handleStoreUpdate = (topic, data) => {
        this.setState({
            "memberState": MemberStore.getState(),
            "profileState": ProfileStore.getState()
        });
    };

    render() {
        if (this.state.memberState.loadingState !== LoadingStates.FINISHED_LOADING ||
            (this.isReadyForProfile() && this.state.profileState.loadingState !== LoadingStates.FINISHED_LOADING)) {
            return (
                <ForcedViewPrivateWrapper usesDefaultFooter={this.props.usesDefaultFooter}>
                    <LoadingView titleText="Loading Profile" />
                </ForcedViewPrivateWrapper>
            );
        }

        if (!this.state.memberState.profileCreated) {
            Logger.info("No profile yet created for member.  Forcing profile create.");
            return (
                <ForcedViewPrivateWrapper usesDefaultFooter={this.props.usesDefaultFooter}>
                    <ProfileCreateContainer />
                </ForcedViewPrivateWrapper>
            );
        }

        if (!this.state.memberState.emailVerified) {
            Logger.info("Email not yet verified for member.  Forcing email verification.");
            return (
                <ForcedViewPrivateWrapper usesDefaultFooter={this.props.usesDefaultFooter}>
                    <EmailVerificationContainer email={this.state.profileState.email} />
                </ForcedViewPrivateWrapper>
            );
        }

        if (!this.state.memberState.smsVerified) {
            Logger.info("Phone number not yet verified for member.  Forcing sms verification.");
            return (
                <ForcedViewPrivateWrapper usesDefaultFooter={this.props.usesDefaultFooter}>
                    <PhoneNumberVerificationContainer phoneNumber={this.state.profileState.phoneNumber} />
                </ForcedViewPrivateWrapper>);
        }

        return (
            <PrivateWrapper usesDefaultFooter={this.props.usesDefaultFooter}>
                {this.props.children}
            </PrivateWrapper>
        );
    }

    requestViewRequiredData() {
        if (this.state.memberState.loadingState === LoadingStates.INITIALIZED) {
            EventPublisher.publish(UIInteractionEvents.RENDERED_VIEW_REQUIRES_MEMBER, {});
        }
        if (this.isReadyForProfile() && this.state.profileState.loadingState === LoadingStates.INITIALIZED
        ) {
            EventPublisher.publish(UIInteractionEvents.RENDERED_VIEW_REQUIRES_PROFILE, {});
        }
    }

    isReadyForProfile() {
        return this.state.memberState.loadingState === LoadingStates.FINISHED_LOADING &&
            this.state.memberState.profileCreated;
    }
}

export default PrivateWrapperContainer;